/* eslint-disable-next-line no-shadow */
export enum GenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  NOT_INFORMED = 'NOT_INFORMED',
}

export interface IRegistrationFormData {
  name: string,
  cpf?: string,
  crf?: string,
  crfUf?: string,
  birthDate?: string,
  gender: GenderEnum,
  DDD: string,
  phone: string,
  email: string,
  password: string,
  confirmPassword: string,
}

export interface IPharmaceuticalRegistrationFormData {
  name: string,
  cpf: string,
  crf: string,
  crfUf: string,
  birthDate: string,
  gender: GenderEnum,
  DDD: string,
  phone: string,
  email: string,
  password: string,
  confirmPassword: string,
}

export type IDefaultPharmaceuticalValueRegistrationFormData = Omit<
  IPharmaceuticalRegistrationFormData,
  | 'password'
  | 'confirmPassword'
> & {
  password?: string;
  confirmPassword?: string;
  oldPassword?: string;
};

export interface IUpdatedPharmaceutical {
  name: string,
  cpf: string,
  crf: string,
  crfUf: string,
  birthDate: string,
  gender: GenderEnum,
  cellphone: string,
  email: string,
  password?: string,
  confirmPassword?: string,
  oldPassword?: string
}
